import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var immediateBackground = colors.interactive.surface.hover;
export var immediateText = colors.interactive.base.default;
export var title = {
  name: "e2rbaa",
  styles: "mark{color:inherit;background-color:inherit;font-weight:900;}"
};
export var avatar = /*#__PURE__*/css("width:20px;height:20px;button:hover & path{color:", colors.neutral.medium.default, " !important;}");
export var label = {
  name: "1vkab4s",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"
};